import { Collapse } from "bootstrap";

export default class CheckboxCollapse extends HTMLInputElement {


    connectedCallback() {

        this.addEventListener('change', this.handleChange);
        
    }

    disconnectedCallback() {

        this.removeEventListener('change', this.handleChange);

    }

    get collapseTarget() {
        return document.querySelector(`#${this.getAttribute("aria-controls")}`);
    }

    handleChange = e => {

        this.setAttribute("aria-expanded", this.checked ? "true" : "false");

        if (this.checked) {
            new Collapse(this.collapseTarget, {
                show: true
            });
        }
        else {
            new Collapse(this.collapseTarget, {
                hide: true
            });
        }

    }

}

customElements.define('checkbox-collapse', CheckboxCollapse, { extends: 'input' });